<template>
  <section class="sectionSize items-start pt-8 md:pt-14 bg-black text-white">
    <div>
      <h2 class="secondaryTitle bg-underline2 bg-100%">{{ t('faq.title') }}</h2>
    </div>

    <div
      v-for="(item, i) in items"
      :key="i"
      class="w-full"
    >
      <div
        class="w-full py-4 cursor-pointer faq-item"
        @click="toggle(i)"
      >
        <div class="flex justify-between items-center">
          <div class="font-montserrat font-medium mr-auto pr-8">{{ item.q }}</div>
          <img
            src="/caret-right.svg"
            alt=""
            class="transform transition-transform flex-shrink-0"
            :class="open === i ? 'rotate-90' : ''"
          >
        </div>
        <div
          class="font-montserrat text-sm font-extralight pb-4 text-white/70 overflow-hidden transition-all"
          :class="open === i ? 'mt-3 max-h-96' : 'max-h-0'"
        >
          {{ item.a }}
        </div>
      </div>
      <hr class="w-full border-white/20">
    </div>
  </section>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { FAQ_DATA } from '~/config/faq'

const { t, locale } = useI18n()
const open = ref<number | null>(null)

const items = computed(() => FAQ_DATA[locale.value] ?? FAQ_DATA.uk)

function toggle(i: number) {
  open.value = open.value === i ? null : i
}
</script>

<style scoped>
.faq-item {
  border-radius: 8px;
  padding-left: 12px;
  padding-right: 12px;
  margin-left: -12px;
  margin-right: -12px;
  background: transparent;
  transition: background 0.2s ease;
}

/* Плавне підсвічення при ховері */
.faq-item:hover {
  background: rgba(255, 255, 255, 0.05);
  animation: faqFlash 0.5s ease forwards;
}

@keyframes faqFlash {
  0%   { background: transparent; }
  30%  { background: rgba(255, 255, 255, 0.12); }
  60%  { background: rgba(255, 255, 255, 0.04); }
  100% { background: rgba(255, 255, 255, 0.05); }
}
</style>
